import { render, staticRenderFns } from "./AvailabilityLangsForm.vue?vue&type=template&id=d2f1966a&"
import script from "./AvailabilityLangsForm.vue?vue&type=script&lang=js&"
export * from "./AvailabilityLangsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports